/* eslint-disable */
import axios from 'axios';
import store from "../../store/index";
import moment from "moment";
import customModal from "../customModal/customModal.vue";
import ChangesdvVerification from "../Changesdverification/ChangesdvVerification.vue";
import AssignSdvModal from "../AssignSdvModal/AssignSdvModal.vue";

export default{
    name: 'dataSignal',
    components: {
        customModal,
        ChangesdvVerification,
        AssignSdvModal
    },
    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            studyId: "",
            showRiskRegisterModal: false,
            idToken: store.getters.getIdToken,
            headerValues: {},
            selectedcolumnobj: {},
            selectedColumns: [],
            getColumns: [],
            showFilter: false,
            dropdownOpen: false,
            selectedCriticalDP: {},
            selectedSignalId: "",
            signalId: "",
            outcome: "",
            siteCode: "",
            isSDV: "",
            criticalDataPoints:[],
            showIsVerfySDVModal: false,
            showIsAssignSDVModal: false,
            showTableLoader: false,
            
        };
    },
    async mounted() {
        this.defaultdate = localStorage.getItem("dateformat");
        this.defaultTime = localStorage.getItem("timeformat");
        this.filter();
        this.idtoken = store.getters.getIdToken;
        this.studyId = store.getters.getStudyIs;
        console.log('CriticalDataInventory component mounted');
        this.headerValues = {
            headers: {
                Authorization: "Bearer " + this.idToken,
                "Content-Type": "application/json",
            },
        };
        window.addEventListener("studyIdChanged", (event) => {
            console.log("StudyIDChanged into" + event.detail.storage);
            this.studyId = event.detail.storage;
            this.getCriticalProcess();
             this.initializeColumns();
        });
        await  this.getCriticalProcess();
         this.initializeColumns();
    },
    methods: {
         filter(date) {
              if (date) {
                return moment(date).format(this.defaultdate)
              }
            },
            toTime(data) {
      if (data) {
        return moment(data).format(this.defaultTime);
      }
    },
    initializeColumns() {
      if (this.criticalDataPoints.length > 0) {
        const allowedKeys = [
          "signalId",
          "category",
          "technique",
          "siteCode",
          "fieldName",
          "observedMetric",
          "benchmarkThreshold",
          "flagType",
          "isSDV",
          "level",
          "sdvStatus",
          "sdvOutcome",
          "isSDVAssign",
          "CreatedAt",
          "CreatedUserEmail",         
          
        ];
        this.getColumns = Object.keys(this.criticalDataPoints[0]).filter((column) =>
          allowedKeys.includes(column)
        );
        console.log("Columns:", this.getColumns);
        // Add new field labels for the additional columns
        const fieldLabels = {
          signalId: "Signal ID",
          category: "Category",
          technique: "Technique",
          siteCode: "Site Code",
          fieldName: "Field Name",
          observedMetric: "Observed Metric",
          benchmarkThreshold: "Benchmark Threshold",
          flagType: "Outcome",         
          isSDV: "SDV Required",
          level: "Level",
          sdvStatus: "SDV Status",
          sdvOutcome: "SDV Outcome",
          isSDVAssign: "SDV Assigned",
          CreatedAt: "Run Date",
          CreatedUserEmail: "Run By"
        };
 
        const readableData = allowedKeys.map((key) => fieldLabels[key] || key);
        const initiallyTrueKeys = ["Signal ID","Category","Technique","Site Code","Field Name","Observed Metric","Benchmark Threshold","Outcome","SDV Required","Level","SDV Status","SDV Outcome","SDV Assigned","Run Date","Run By"];
 
        this.getColumns = readableData;
        this.selectedColumns = initiallyTrueKeys;
        this.selectedcolumnobj = this.getColumns.reduce((obj, key) => {
          obj[key] =initiallyTrueKeys.includes(key);
          return obj;
        }, {});
        console.log("object", this.selectedColumns);
      }
    },
    async verifySDV(CriticalDP) {
        this.showIsVerfySDVModal = true;
        this.selectedCriticalDP = CriticalDP || {};
        console.log("Critical Data Point clicked:",  this.selectedCriticalDP);
    },
    async assignSDV(signalId) {
        this.showIsAssignSDVModal = true;
        this.selectedSignalId = signalId;
        console.log("Signal ID clicked:",  this.selectedSignalId);
    },
    async closemodal() {
        this.showIsVerfySDVModal = false;
        this.showIsAssignSDVModal = false;
        this.getreloadDataProcess();
    },
    async closeRiskReg() {
        this.showRiskRegisterModal = false;
      },

        async getCriticalProcess() {
            try {
            this.showTableLoader = true;
            const res = await axios.get(
                `${this.baseurl}/forms/rbqm/getdatasignal?studyId=${this.studyId}`,
                this.headerValues
            );
            console.log("Critical Data Points:", res.data);
            this.criticalDataPoints = res.data || [];
            } catch (error) {
            console.error("Error fetching critical data points:", error);
            } finally {
            this.showTableLoader = false;
            }
        },
            async getreloadDataProcess() {
            try {
           
            const res = await axios.get(
                `${this.baseurl}/forms/rbqm/getdatasignal?studyId=${this.studyId}`,
                this.headerValues
            );
            console.log("Critical Data Points:", res.data);
            this.criticalDataPoints = res.data || [];
            } catch (error) {
            console.error("Error fetching critical data points:", error);
            } finally {
            this.showTableLoader = false;
            }
        },
    async getSearchData() {
      try {
        this.showTableLoader = true;
        let query = `${this.baseurl}/forms/rbqm/getdatasignal?studyId=${this.studyId}`;
       
        if (this.siteCode) {
          query += `&siteCode=${encodeURIComponent(this.siteCode)}`;
        }
        const res = await axios.get(query, this.headerValues);
        console.log("Search Results:", res.data);
        this.criticalDataPoints = res.data || [];
      } catch (error) {
        console.error("Error fetching search results:", error);
      } finally {
        this.showTableLoader = false;
      }
    }
    },
   
}